import { IGerenciamentoDocumento, GerenciamentoDocumentoSituacao } from '../models/gerenciamentodocumento.model';

export const GERENCIAMENTO_DOCUMENTOS_MOCK: IGerenciamentoDocumento[] = [
    {
        id: '8f184f62-8b0b-4e5a-94cf-6f7c5d1a0001',
        matricula: '000123',
        colaborador: 'Ana Souza',
        tipodocumento: 'Recibo de pagamento',
        referencia: '01/2024',
        datageracao: '05/02/2024',
        situacaoatual: 'Liberado',
        detalhes: 'Documento liberado para visualização',
        situacao: GerenciamentoDocumentoSituacao.Entregue,
        historico: [
            {
                id: 'hist-0001-1',
                titulo: 'Visualizado pelo colaborador',
                dataHora: '10/11/2025 às 14:32',
                descricao: 'Documento visualizado através do portal do colaborador.',
                categoria: 'sistema'
            },
            {
                id: 'hist-0001-2',
                titulo: 'Notificação reenviada',
                dataHora: '09/11/2025 às 10:15',
                responsavel: 'Maria Lima',
                descricao: 'Reenviado após solicitação do RH.',
                categoria: 'manual'
            }
        ]
    },
    {
        id: '8f184f62-8b0b-4e5a-94cf-6f7c5d1a0002',
        matricula: '000456',
        colaborador: 'Bruno Lima',
        tipodocumento: 'Comprovante de Rendimentos',
        referencia: '2023',
        datageracao: '15/03/2024',
        situacaoatual: 'Pendente',
        detalhes: 'Aguardando liberação do gestor',
        situacao: GerenciamentoDocumentoSituacao.PendenteLiberacao,
        historico: [
            {
                id: 'hist-0002-1',
                titulo: 'Envio pendente',
                dataHora: '08/11/2025 às 09:10',
                descricao: 'Documento aguardando liberação do gestor.',
                categoria: 'sistema'
            }
        ]
    },
    {
        id: '8f184f62-8b0b-4e5a-94cf-6f7c5d1a0003',
        matricula: '000789',
        colaborador: 'Carlos Andrade',
        tipodocumento: 'Informe de Rendimentos',
        referencia: '2023',
        datageracao: '10/03/2024',
        situacaoatual: 'Reenviado',
        detalhes: 'Reenvio realizado em 12/03/2024',
        situacao: GerenciamentoDocumentoSituacao.Assinado,
        historico: [
            {
                id: 'hist-0003-1',
                titulo: 'Documento reenviado',
                dataHora: '12/03/2024 às 16:48',
                descricao: 'Reenvio realizado automaticamente após atualização de dados.',
                categoria: 'sistema'
            },
            {
                id: 'hist-0003-2',
                titulo: 'Documento liberado',
                dataHora: '11/03/2024 às 14:05',
                descricao: 'Documento liberado para visualização do colaborador.',
                categoria: 'manual'
            }
        ]
    },
    {
        id: '8f184f62-8b0b-4e5a-94cf-6f7c5d1a0004',
        matricula: '000321',
        colaborador: 'Daniela Ferreira',
        tipodocumento: 'Aviso de Férias',
        referencia: '02/2024',
        datageracao: '20/02/2024',
        situacaoatual: 'Liberado',
        detalhes: 'Documento confirmado pela colaboradora',
        situacao: GerenciamentoDocumentoSituacao.PendenteAssinatura,
        historico: [
            {
                id: 'hist-0004-1',
                titulo: 'Confirmação registrada',
                dataHora: '20/02/2024 às 11:22',
                descricao: 'Confirmação registrada pelo portal do colaborador.',
                categoria: 'manual'
            }
        ]
    },
    {
        id: '8f184f62-8b0b-4e5a-94cf-6f7c5d1a0005',
        matricula: '000654',
        colaborador: 'Eduardo Pereira',
        tipodocumento: 'Aviso de Férias',
        referencia: '02/2024',
        datageracao: '05/03/2024',
        situacaoatual: 'Erro',
        detalhes: 'Falha na geração automática',
        situacao: GerenciamentoDocumentoSituacao.PendenteLiberacao,
        disableCheckbox: true,
        rowcustomclass: 'table-row-danger',
        historico: [
            {
                id: 'hist-0005-1',
                titulo: 'Erro de geração',
                dataHora: '05/03/2024 às 08:05',
                descricao: 'Falha identificada na geração do documento.',
                categoria: 'falha'
            }
        ]
    }
];
